import React from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000; /* Ensure overlay is on top */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled(motion.div)`
  width: 90%;
  max-width: 600px;
  height: auto;
  max-height: 80%;
  background-color: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  z-index: 1001; /* Ensure modal container is above overlay */

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const CloseButton = styled.svg`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 18px;
  top: 18px;
  cursor: pointer;
  z-index: 1002; /* Ensure close button is above everything */
`;

const modalVariant = {
  initial: { opacity: 0 },
  isOpen: { opacity: 1 },
  exit: { opacity: 0 },
};

const containerVariant = {
  initial: { y: "-50%", transition: { type: "spring", duration: 0.5 } },
  isOpen: { y: "0%" },
  exit: { y: "-50%" },
};

interface ModalProps {
  handleClose: () => void;
  children: React.ReactNode;
  isOpen: boolean;
}

const Modal: React.FC<ModalProps> = ({ handleClose, children, isOpen }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <Overlay
          initial="initial"
          animate="isOpen"
          exit="exit"
          variants={modalVariant}
          aria-modal="true"
          role="dialog"
        >
          <ModalContainer
            className="modal-content"
            variants={containerVariant}
            initial="initial"
            animate="isOpen"
            exit="exit"
          >
            <CloseButton
              onClick={handleClose}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20.39 20.39"
              aria-label="Close"
            >
              <title>close</title>
              <line
                x1="19.39"
                y1="19.39"
                x2="1"
                y2="1"
                fill="none"
                stroke="#ff4d4f"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
              <line
                x1="1"
                y1="19.39"
                x2="19.39"
                y2="1"
                fill="none"
                stroke="#ff4d4f"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
            </CloseButton>
            {children}
          </ModalContainer>
        </Overlay>
      )}
    </AnimatePresence>
  );
};

export default Modal;
